import {LearningCenterModuleDefinition} from './learningCenterModule'

export {LearningCenterModuleDefinition}
